"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsSizeGuideViewedTypes = exports.AnalyticsSizeGuideAvailabilityTypes = void 0;
var AnalyticsSizeGuideAvailabilityTypes;
(function (AnalyticsSizeGuideAvailabilityTypes) {
    AnalyticsSizeGuideAvailabilityTypes["AVAILABLE"] = "available";
    AnalyticsSizeGuideAvailabilityTypes["NOT_AVAILABLE"] = "not available";
})(AnalyticsSizeGuideAvailabilityTypes || (exports.AnalyticsSizeGuideAvailabilityTypes = AnalyticsSizeGuideAvailabilityTypes = {}));
var AnalyticsSizeGuideViewedTypes;
(function (AnalyticsSizeGuideViewedTypes) {
    AnalyticsSizeGuideViewedTypes["VIEWED"] = "viewed";
    AnalyticsSizeGuideViewedTypes["NOT_VIEWED"] = "not viewed";
})(AnalyticsSizeGuideViewedTypes || (exports.AnalyticsSizeGuideViewedTypes = AnalyticsSizeGuideViewedTypes = {}));
//# sourceMappingURL=AnalyticsTypes.js.map